import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import dayjs, { Dayjs } from "dayjs";
import { Execution } from "types/List/List.interface";

export interface HomeState {
  data: any[];
  step: number;
  date: Dayjs | string;
  loading: boolean;
  error: any;
  nsoFlowData: Execution;
  //any type object
  simFlowData: Execution;
  status: string;
}

export const homeInitialState: HomeState = {
  data: [],
  step: 0,
  date: dayjs(),
  loading: false,
  error: null,
  nsoFlowData: {
    sNo: 0,
    urn: "",
    soldOrderNumber: "",
    dealerCode: "",
    flowdetailid: "",
    status: "",
    date: "",
    time: "",
    plantsourcecode: "",
    salesseriesname: "",
    NsoIcon: undefined,
    SIMIcon: undefined,
  },
  simFlowData: {
    sNo: 0,
    urn: "",
    soldOrderNumber: "",
    dealerCode: "",
    flowdetailid: "",
    status: "",
    date: "",
    time: "",
    plantsourcecode: "",
    salesseriesname: "",
    NsoIcon: undefined,
    SIMIcon: undefined,
  },
  status: "COMPLETE",
};

// Retrieve the initial state from localStorage if available
const storedState = localStorage.getItem("homeState");
const initialState = storedState
  ? JSON.parse(storedState)
  : {
      home: homeInitialState,
    };

export const homeSlice = createSlice({
  name: "home",
  initialState: initialState,
  reducers: {
    homeFetchData: (state) => {
      state.home.loading = true;
      state.home.error = null;
    },
    setHomeStatus: (state, action) => {
      state.home.status = action.payload;
    },
    homeFetchDataSuccess: (state, action: PayloadAction<any[]>) => {
      state.home.data = action.payload;
      state.home.loading = false;
      state.home.error = null;
    },
    homeFetchDataFailure: (state, action: PayloadAction<any>) => {
      state.home.loading = false;
      state.home.error = action.payload;
    },
    homeSetDate: (state, action: PayloadAction<string>) => {
      state.home.date = action.payload;
    },
    homeResetDate: (state) => {
      state.home.date = "";
    },
    homeSetStep: (state, action: PayloadAction<number>) => {
      state.home.step = action.payload;
    },
    homeSetNsoFlowData: (state, action: PayloadAction<Execution>) => {
      state.home.nsoFlowData = action.payload;
    },
    homeSetSimFlowData: (state, action: PayloadAction<Execution>) => {
      state.home.loading = true;
      state.home.simFlowData = action.payload;
      state.home.loading = false;
    },
  },
});

export const {
  homeFetchData,
  homeFetchDataSuccess,
  homeFetchDataFailure,
  homeSetStep,
  homeSetDate,
  homeResetDate,
  homeSetNsoFlowData,
  homeSetSimFlowData,
} = homeSlice.actions;

export const selectHome = (state: RootState) => state.home;

// Save the state to localStorage whenever it changes
export const homeSliceReducer = homeSlice.reducer;
homeSlice.reducer = (state, action) => {
  const newState = homeSliceReducer(state, action);
  localStorage.setItem("homeState", JSON.stringify(newState));
  return newState;
};

export default homeSlice.reducer;
